import { DatePicker, Modal } from "antd";
import React, { useEffect, useState } from "react";
import rpmService from "../../../../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import { convertUTCDate } from "../../../../../../../utils/convertionFunc";
import {
  fetchRpmCPDailyMedicationList,
  fetchRpmCPMedicationsList,
} from "../../../../../../../Redux/actions/rpmActions";
import dayjs from "dayjs";

function UpdateDailyMedications({ handleClose }) {
  const [loader, setLoader] = useState(false);
  const [enteredDate, setEnteredDate] = useState(dayjs());
  const dispatch = useDispatch();
  const { careMedicationsList, selectedRpmPatient } = useSelector(
    (state) => state.rpm
  );
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const payload = {
      patientCode: selectedRpmPatient.patientId,
      rpm: "Y",
      status: 1,
      fromDate: dayjs(enteredDate).format("MM/DD/YYYY"),
      toDate: dayjs(enteredDate).format("MM/DD/YYYY"),
    };
    dispatch(fetchRpmCPMedicationsList(payload));
  }, [enteredDate, dispatch, selectedRpmPatient.patientId]);

  const handleDailyMedicationsUpdate = async (actionType) => {
    let finalPayloadArr = [];
    setLoader(true);
    finalPayloadArr = careMedicationsList.map((medication) => {
      return {
        account_Id: selectedRpmPatient.account_Id,
        clinic_Id: selectedRpmPatient.clinic_id,
        createdBy: loggedUser?.user?.userId,
        createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        dosage: medication.dosage,
        dose: medication.dose,
        drugName: medication.drugName,
        frequency: medication.frequency,
        givenDate: convertUTCDate(enteredDate, "YYYY-MM-DD HH:mm:ss"),
        medicationTaken: actionType,
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        patientCode: selectedRpmPatient.patientId,
        status: 1,
        userId: selectedRpmPatient.createdBy,
        enteredBy: loggedUser?.user?.userId,
      };
    });

    try {
      await rpmService.updateCarePlanDailyMedications(finalPayloadArr);
      const payload = {
        patientCode: selectedRpmPatient.patientId,
        status: 1,
      };
      dispatch(fetchRpmCPDailyMedicationList(payload));
      setLoader(false);
      handleClose();
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  const handleEnteredDate = (date) => {
    setEnteredDate(date);
  };

  return (
    <div>
      <div>
        <div className="p-4">
          <div className="mb-4 w-96 flex gap-2 items-center">
            <label className="font-medium mb-1">Entered On:</label>
            <DatePicker onChange={handleEnteredDate} defaultValue={dayjs()} />
          </div>

          <div className="h-[400px] overflow-y-scroll scrollWidth space-y-4">
            {careMedicationsList?.map((item, idx) => (
              <div key={idx} className="border rounded-lg p-4 space-y-2">
                <p className="text-sm font-semibold text-gray-700">
                  {item.drugName}
                </p>
                <div className="flex justify-between">
                  <p className="text-sm font-medium text-gray-700">
                    {item.frequency}
                  </p>
                  <p className="text-sm font-medium text-gray-700">
                    {item.endCreatedTime?.split(" ")[0]}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-between mt-2">
            <p className="font-medium text-gray-700">All Medications Taken?</p>
            <div className="flex gap-2 justify-end">
              <button
                disabled={loader}
                onClick={() => handleDailyMedicationsUpdate("N")}
                className="border rounded-md bg-white text-brand-primaryColor border-brand-primaryColor px-4 py-1 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                No
              </button>
              <button
                disabled={loader}
                onClick={() => handleDailyMedicationsUpdate("Y")}
                className="border rounded-md text-white bg-brand-primaryColor px-4 py-1 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateDailyMedications;
